"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.GUIBase = void 0;
const dat_gui_1 = require("dat.gui");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
class GUIBase {
    static get parentGui() {
        if (!this._gui) {
            this._gui = new dat_gui_1.GUI({
                name: 'Streem SDK GUI',
                hideable: false,
                closed: true,
            });
            if (this._gui.domElement.parentElement) {
                this._gui.domElement.parentElement.style.zIndex = '10000';
            }
            this.hasGUI.next(true);
        }
        return this._gui;
    }
    static createFolder(name) {
        return this.parentGui.addFolder(name);
    }
    static removeGui() {
        if (this._gui) {
            this._gui.destroy();
            this._gui = undefined;
            this.hasGUI.next(false);
        }
    }
}
exports.GUIBase = GUIBase;
_a = GUIBase;
GUIBase.hasGUI = new rxjs_1.Subject();
GUIBase.onGUIDestroyed = _a.hasGUI.asObservable().pipe(
// Filter to when when hasGUI = false
(0, operators_1.filter)(x => !x));
//# sourceMappingURL=gui_base.js.map